angular.module('rjmNg.directives').controller 'tablePreviewCtrl', [
  '$scope'
  'Columns'
  'dateService'
  'app'
  '$timeout'
  '$element'
  'tablePreviewSampling'
  'notification'
  "errorConstants"
  '$q'
  '$rootScope'
  (
    $scope
    Columns
    dateService
    app
    $timeout
    $element
    tablePreviewSampling
    notification
    errorConstants
    $q
    $rootScope
  ) ->
    SERVER_ERROR_MESSAGE = "There is an issue with our servers. Please wait a
    few minutes and try again."
    DERIVATIVE_SAMPLER_MESSAGE = "We are having trouble calculating some of your
     columns which are pending an update. Please wait a few minutes and try again."

    $scope.pendingUpdate = false
    $scope.sampledData = null
    # Adding/removing a column to columns/dataToDisplay should be followed by
    # a call to redrawTable.
    $scope.columns = null
    $scope.dataToDisplay = null
    $scope.builder =
      show: false
    $scope.visibility =
      loadingGif: false
      blockTable: false
    $scope.pendingSample = false
    currentSampleRequestId = 0
    $scope.derivativeServiceFailure = false
    $scope.decisions = null

    sampleDeferred = null

    # Returns the currency code for a column. If its field_type is
    # value_currency, but it's currency_code property is null, then use the
    # default currency code for the client.
    getCurrencyCode = (localColumn) ->
      return undefined unless localColumn? and
        localColumn.field_type is 'value_currency'

      localColumn.currency_code ? app.getClientDefaultCurrency().code

    getColumnHeaderStr = (column) ->
      nameAndDecorations = [_.escape(column.name)]

      if column.field_type is 'value_currency'
        nameAndDecorations.push("<span class='ce-label-decoration' ng-show='currencyCode'>#{getCurrencyCode(column)}</span>")

      if column.primary_key_index
        nameAndDecorations.push('<i class="icon-key"></i>')

      if column.remote_column_id
        column_type = "Your Database"
      else
        column_type = "Calculated Column"

      """
        <th title='#{_.escape(column.name)}'>
          <span>#{nameAndDecorations.join(' ')}</span>
          <br>
          <span class='detail-text'>#{column_type}</span>
        </th>
      """

    getColumnHeadersStr = (columns) ->
      columnsToShow = columns.filter (column) ->
        not isPendingUpdate(column) and not isPendingAdd(column)

      columnsToShow.map((column) -> getColumnHeaderStr(column)).join('')

    getTableHeader = (columns) ->
      """
      <thead>
        <tr>#{getColumnHeadersStr(columns)}</tr>
      </thead>
      """

    addStyleToColumnHeader = (index, style) ->
      # Datatables creates a separate table for the header. This is really the best way to
      # select the header element from that table.
      $($element.find('th[role="columnheader"]')).eq(index).addClass(style)

    addStyleToColumn = (index, style) ->
      # nth-child selector is 1 indexed
      $($element.find('#tablePreview tbody tr :nth-child(' + (index+1) + ')')).addClass(style)
      addStyleToColumnHeader(index, style)

    # Columns can have various options set
    getColumnDefs = (colsToLeftAlign, dateCols) ->
      columnDefs = []

      columnDefs.push { sType: "rjmdate", targets: dateCols }

      # Left aligns certain columns
      columnDefs.push { sClass: "dimensionItem", targets: colsToLeftAlign, sType: 'auto' }

      # Use strippedNumerics sort logic for all other columns
      columnDefs.push { sType: "strippedNumerics", targets: ['_all'] }

      return columnDefs

    $scope.redrawTable = () ->
      if not $scope.tableId? or not $scope.tableName? or not $scope.dataToDisplay?
        # there's not anything there for us to actually redraw
        return

      updateVisibility true

      # Datatables does not support dynamic addition/removal of columns.
      # Therefore we destroy and recreate the table to add/remove columns.
      if $scope.dataTable
        $scope.dataTable.clear()
        $scope.dataTable.destroy()
        $($element.find('#tablePreview')).empty()

      columnDefs = getColumnDefs $scope.dataCols, ['_all']

      fullHeaderHtml = getTableHeader($scope.columns)
      tableElement = $($element.find('#tablePreview')).html(fullHeaderHtml)
      headerRowHeight = $element.find('thead').height()

      $scope.dataTable = tableElement.DataTable(
        deferRender: true
        destory: true
        paging: false
        info: false
        scrollY: '45vh'
        scrollX: $element.parent().width()
        searching: false
        order: []   # Prevents us from sorting upon loading
        columnDefs: columnDefs
        data: $scope.dataToDisplay
      )

      for column, index in $scope.columns
        if isPendingAdd(column)
          addStyleToColumn(index, 'pending-add')
        else if isPendingUpdate(column)
          addStyleToColumn(index, 'pending-update')

        decisionAction = $scope.decisions.getActionByColumnId(column.id)
        addStyleToColumnHeader(index, 'decision-' + decisionAction)

      updateVisibility false

    # The column has not yet been saved
    isPendingAdd = (column) ->
      column? and (not column.id? or column.id is 0)

    # The column has been saved, but an update has not been run.
    isPendingUpdate = (column) ->
      column? and not (isPendingAdd(column) or column.is_in_serving_layer)

    renderDateValues = (dataSet) ->
      newDataSet =
        table: dataSet.table
        columns: dataSet.columns
        dates: []

      types = _(dataSet.columns).map (column) ->
        column.data_type.type

      newDataSet.data = _(dataSet.data).map (row) ->
        newRow = []
        for i in [0..(types.length-1)] by 1
          newRow.push row[i]
        return newRow
      return newDataSet

    # Replace nulls with "null" strings and remove unsafe HTML
    processForDisplay = (dataSet) ->
      newDataSet =
        table: dataSet.table
        columns: dataSet.columns

      newDataSet.data = _(dataSet.data).map (row) ->
        newRow = []
        for item in row
          if item?
            if angular.isString(item)
              newRow.push _.escape(item)
            else
              newRow.push item
          else
            newRow.push "<em>null</em>"
        return newRow
      return newDataSet

    addColumnsWithoutData = (columns, dataSet) ->
      newDataSet = angular.copy dataSet
      for column in columns
        if not (c for c in newDataSet.columns when c.id == column.id)[0]
          newDataSet.columns.push column
          for row in newDataSet.data
            row.push ""
      return newDataSet

    moveColumn = (dataSet, oldIndex, newIndex) ->
      if oldIndex == newIndex
        return dataSet
      newDataSet = angular.copy dataSet
      reorder = (arr) ->
        item = arr.splice(oldIndex, 1)[0]
        arr.splice(newIndex, 0, item)
      reorder(newDataSet.columns)
      for row in newDataSet.data
        reorder(row)
      return newDataSet

    renderTable = (tableId, decisions, dataSets) ->
      unless dataSets?
        return
      displayDataSet = d for d in dataSets when d.table.id is tableId
      sanitizedDataSet = processForDisplay(displayDataSet)
      renderedDataSet = renderDateValues(sanitizedDataSet)

      failedCols = decisions.getAllForTable($scope.tableId).getFailedColumns()
      filledDataSet = addColumnsWithoutData failedCols, renderedDataSet

      indexOfNewColumn = (i for c, i in filledDataSet.columns when not c.id)[0]
      if indexOfNewColumn?
        finalDataSet = moveColumn(filledDataSet, indexOfNewColumn, filledDataSet.columns.length)
      else
        finalDataSet = filledDataSet

      $scope.columns = finalDataSet.columns
      $scope.dataToDisplay = finalDataSet.data
      $scope.dateCols = finalDataSet.dates
      $scope.redrawTable()

    getColumnIndex = (column) ->
      (i for c,i in $scope.columns when c.id == column.id)[0]

    runNewFullSampling = (tableId, columns, force=false) ->
      if sampleDeferred?
        sampleDeferred.resolve(null)
      sampleDeferred = $q.defer()
      #Don't calculate derivatives
      tablePreviewSampling.decide(columns)
      .then (decisions) ->
        $scope.decisions = decisions
        if decisions.getAllForTable(tableId).getColumnsToSample().length == 0
          $scope.pendingUpdate = true
        else
          $scope.pendingUpdate = false
          $scope.pendingSample = true
          currentSampleRequestId++
          requestId = currentSampleRequestId
          updateVisibility true
          tablePreviewSampling.getAllData(decisions, sampleDeferred, force)
          .finally () ->
            $scope.pendingSample = false
          .then (result) ->
            handleSampleData tableId, decisions, result?.sampledData, result?.calculatedData, requestId
          .catch (e) ->
            if e?.sampledData? and requestId is currentSampleRequestId
              $scope.derivativeServiceFailure = true
              notification.error 'Server Error', DERIVATIVE_SAMPLER_MESSAGE
              handleSampleData tableId, decisions, e.sampledData, e.sampledData, requestId
            else if requestId is currentSampleRequestId
              notification.error "Server Error", errorConstants.SERVER_ERROR_MESSAGE
              updateVisibility false, true
      .catch (e) ->
        notification.error "Server Error", errorConstants.SERVER_ERROR_MESSAGE
        updateVisibility false, true

    handleSampleData = (tableId, decisions, sampledData, calcData, requestId) ->
      if sampledData? and calcData? and requestId is currentSampleRequestId
        $scope.sampledData = sampledData
        renderTable tableId, decisions, calcData

    updateVisibility = (displayData, error = false) ->
      if error
        $scope.dataToDisplay = null
      $scope.visibility.blockTable = displayData or $scope.pendingSample or error
      $scope.visibility.loadingGif = (displayData or $scope.pendingSample) and not error

    $scope.forceNewSampleData = () ->
      runNewFullSampling $scope.tableId, $scope.columns, true

    loadTable = (tableId) ->
      unless tableId?
        return

      updateVisibility true
      Columns.query(
        'tid': tableId
        'state': ['active']
      , true
      ).then (columns) ->
        runNewFullSampling tableId, columns
      , (error) ->
        notification.error "Server Error", errorConstants.SERVER_ERROR_MESSAGE
        updateVisibility false, true

    # Full reload of data
    $scope.$on 'tablePreviewRefresh', (event) ->
      loadTable $scope.tableId

    # Simple redraw of table
    $scope.$on 'tablePreviewRedraw', (event) ->
      $scope.redrawTable()

    $scope.$watch 'tableId', (tableId) ->
      if tableId?
        loadTable tableId

    clearPreviewColumns = () ->
      $scope.columns = _.filter $scope.columns, (existingColumn) ->
        existingColumn.id? and existingColumn.id isnt 0

    $rootScope.$on 'clearPreviewColumn', (event) ->
      clearPreviewColumns()
      $scope.redrawTable()

]

angular.module('rjmNg.directives').directive 'tablePreview', [
  () ->
    restrict: 'E'
    templateUrl: 'directive.tablePreview.html'
    scope:
      tableId: '='
      tableName: '='
    controller: 'tablePreviewCtrl'
]
